import * as React from 'react'
import { useIntl } from 'gatsby-plugin-react-intl'

import SunIcon from 'images/ico_sun_white.svg'
import CloudyIcon from 'images/ico_cloudy_white.svg'
import RainyIcon from 'images/ico_rainy_white.svg'
import DarkSunIcon from 'images/ico_sun_black.svg'
import SeaTemperatureIcon from 'images/ico_sea_temperature_white.svg'
import DarkSeaTemperatureIcon from 'images/ico_sea_temperature_black.svg'
import {Degrees} from "../Degrees";

type InfoSectionProps = {
	sectionTitle: string,
	isTemperature?: boolean,
	isSeaTemperature?: boolean,
    isNumberOfDays?: boolean,
    season?: 'sun' | 'cloudy' | 'rainy',
	amount: number,
	isDark?: boolean
}
const iconMapping = {
    sun: SunIcon,
    cloudy: CloudyIcon,
    rainy: RainyIcon
}

export const InfoSection = ({
	sectionTitle,
	isTemperature,
	isSeaTemperature,
	isNumberOfDays,
    amount,
    season,
	isDark
}: InfoSectionProps) => {
    season = season || 'sun';
    let imageSrc = iconMapping[season];
    const intl = useIntl()
	let formattedText = (
		<p className={`card__info__text ${isDark && 'card__info__text--dark'}`}>
            {amount} <small>/{ intl.formatMessage({id:'common.month'}) }</small>
		</p>
	)
	//if (isDark) imageSrc = DarkSunIcon
	if (isSeaTemperature) imageSrc = SeaTemperatureIcon
	if (isSeaTemperature && isDark) imageSrc = DarkSeaTemperatureIcon
	if (isTemperature)
		formattedText = (
			<p className={`card__info__text ${isDark && 'card__info__text--dark'}`}>
				<Degrees degrees={amount} />
			</p>
		)
    
	return (
		<div className="card__info__temperatures">
			<div className={`h6 card__info__temperatures__heading ${isDark && 'card__info__temperatures__heading--dark'}`}>
				{sectionTitle}
			</div>
			<div className="card__info__temperatures__info--wrapper">
				{!isNumberOfDays && (
					<img src={imageSrc} alt="" className="card__info__icon" />
				)}
				{formattedText}
			</div>
		</div>
	)
}